"use client";

import { QuoteIcon } from "@/components/icons/quote.icon";
import { QueryLink } from "@/components/queryLink/queryLink.component";
import { Text } from "@/components/text/text.component";

import { FREE_QUOTE_DRAWER_SEARCH_PARAM } from "./freeQuoteDrawer.constants";
import { FREE_QUOTE_DRAWER_CONTENT } from "./freeQuoteDrawer.defaults";

export const FreeQuoteTrigger = ({
  label,
  ariaLabel,
}: FreeQuoteTriggerProps) => (
  <QueryLink
    set={{ [FREE_QUOTE_DRAWER_SEARCH_PARAM]: "open" }}
    data-testid="site-header-get-quote"
    aria-label={ariaLabel ?? FREE_QUOTE_DRAWER_CONTENT.triggerAriaLabel}
    className="hidden items-center gap-2 lg:flex">
    <span className="flex size-6 shrink-0 items-center justify-center leading-none [&_svg]:block">
      <QuoteIcon className="size-6" />
    </span>
    <Text variant="body3" component="span" className="leading-none">
      {label ?? FREE_QUOTE_DRAWER_CONTENT.triggerLabel}
    </Text>
  </QueryLink>
);

export type FreeQuoteTriggerProps = {
  label?: string | null;
  ariaLabel?: string | null;
};
